import moment from "moment";
import { useEffect, useState } from "react";
import { getWeekColumnData } from "../../utils/annual-planner-helpers";
import submit from "submit-form";

export const useDateSelector = ({ from, startingCalendarDay, statsFrom }) => {
  const [dateFromState, setDateFromState] = useState(from);

  // This useEffect triggers the submit for getting more stats from the athlete
  // Happening when loading months without the athlete stats loaded
  useEffect(() => {
    // If the new date selected in the state is minor than the one getting from the params
    // this means that we have to fetch new data
    if (
      moment(dateFromState).format("YYYYMMDD") <
      moment(statsFrom, "YYYYMMDD").format("YYYYMMDD")
    ) {
      const rearrangedStatsFrom = getWeekColumnData(
        moment(statsFrom, "YYYYMMDD").subtract(1, "year"),
        startingCalendarDay,
        0
      );

      submit("/actions/refresh", {
        method: "GET",
        body: {
          statsFrom: moment(rearrangedStatsFrom, "YYYYMMDD").format("YYYYMMDD"),
          prevFrom: moment(statsFrom, "YYYYMMDD")
            .subtract(1, "day")
            .format("YYYYMMDD"),
        },
      });
    }
  }, [dateFromState]);

  return {
    dateFromState,
    setDateFromState,
  };
};
